import { RouteObject } from "react-router-dom";
import { intakeQuestionOptionsApi } from "src/api/services/intakeQuestionOptionsApi";
import { intakeQuestionsApi } from "src/api/services/intakeQuestionsApi";
import { intakesApi } from "src/api/services/intakesApi";
import { store } from "src/api/store";
import { Matches } from "src/constants/matches";
import { Paths } from "src/constants/paths";
import IntakesDrawerProvider from "src/context/drawers/IntakesDrawerProvider";
import ItemsSelectionProvider from "src/context/ItemsSelectionProvider";
import IntakeBuilder from "src/pages/IntakeBuilder";
import IntakeQuestionOptions from "src/pages/IntakeQuestionOptions";
import IntakeQuestions from "src/pages/IntakeQuestions";
import ProductIntakes from "src/pages/ProductIntakes";

export const intakesPath: RouteObject[] = [
  {
    path: Paths.INTAKES,
    children: [
      {
        index: true,
        element: (
          <IntakesDrawerProvider>
            <ProductIntakes />
          </IntakesDrawerProvider>
        ),
        loader: async ({ params }) => {
          if (params.productId != null) {
            return store.dispatch(
              intakesApi.endpoints.getProductIntakes.initiate({
                productId: params.productId,
              }),
            );
          }
        },
      },
      {
        path: `${Matches.INTAKE_ID}/builder`,
        element: <IntakeBuilder />,
      },
      {
        path: `${Matches.INTAKE_ID}/questions`,
        children: [
          {
            index: true,
            loader: async ({ params }) => {
              if (params.intakeId != null) {
                return store.dispatch(
                  intakeQuestionsApi.endpoints.getIntakeQuestions.initiate(
                    Number(params.intakeId),
                  ),
                );
              }
            },
            element: (
              <IntakesDrawerProvider>
                <ItemsSelectionProvider>
                  <IntakeQuestions />
                </ItemsSelectionProvider>
              </IntakesDrawerProvider>
            ),
          },
          {
            path: Matches.QUESTION_ID,
            loader: async ({ params }) => {
              if (params.intakeId != null && params.questionId != null) {
                return store.dispatch(
                  intakeQuestionOptionsApi.endpoints.getIntakeQuestionOptions.initiate(
                    {
                      intakeId: Number(params.intakeId),
                      questionId: Number(params.questionId),
                    },
                  ),
                );
              }
            },
            element: (
              <IntakesDrawerProvider>
                <IntakeQuestionOptions />
              </IntakesDrawerProvider>
            ),
          },
        ],
      },
    ],
  },
];
